module.exports = __webpack_public_path__ + "img/MKD.74c7d74d.svg";